import { requestHandler } from '../../api';

export const getWallet = async (dispatch: any) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/users/wallet`,
    dispatch,
  });
  if (response) return response.data;
};

export const getBusinessExecutives = async (
  dispatch: any,
  businessIdentifier: string,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/users/${businessIdentifier}/executives`,
    dispatch,
  });
  if (response) return response.data;
};
